var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"to":_vm.getTo(),"exact":true,"disabled":_vm.to == '/messages' || _vm.to == '/documents'}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }